import React from "react";
import { Trans, useTranslation } from "react-i18next";
import { Consignment, ConsignmentData } from "./Consignment";

const DiagmonConsignment = () => {
	const { t } = useTranslation();

	const data: ConsignmentData = {
		groups: [
			{
				header: t("PRIVACY_BDP_CONSIGNMENT_COMPANY_KR"),
				columns: [
					[
						t("PRIVACY_DIAGMON_CONSIGNMENT_SDS_KR"),
						<Trans
							key="aws-kr"
							i18nKey="PRIVACY_DIAGMON_CONSIGNMENT_AWS_KR"
							components={{
								a: (
									// eslint-disable-next-line
									<a
										href="https://aws.amazon.com/ko/compliance/sub-processors/"
										target="_blank"
										rel="noreferrer"
									/>
								),
							}}
						/>,
					],
					[
						t("PRIVACY_DIAGMON_CONSIGNMENT_SDS_OPERATIONS_KR"),
						<Trans
							key="aws-ops-kr"
							i18nKey="PRIVACY_DIAGMON_CONSIGNMENT_AWS_OPERATIONS_KR"
							components={{
								a: (
									// eslint-disable-next-line
									<a
										href="https://aws.amazon.com/ko/compliance/sub-processors/"
										target="_blank"
										rel="noreferrer"
									/>
								),
							}}
						/>,
					],
				],
			},
			{
				header: t("PRIVACY_BDP_CONSIGNMENT_COMPANY"),
				columns: [
					[
						t("PRIVACY_DIAGMON_CONSIGNMENT_SDS"),
						<Trans
							key="aws-en"
							i18nKey="PRIVACY_DIAGMON_CONSIGNMENT_AWS"
							components={{
								a: (
									// eslint-disable-next-line
									<a
										href="https://aws.amazon.com/ko/compliance/sub-processors/"
										target="_blank"
										rel="noreferrer"
									/>
								),
							}}
						/>,
					],
					[
						t("PRIVACY_DIAGMON_CONSIGNMENT_SDS_OPERATIONS"),
						<Trans
							key="aws-ops-en"
							i18nKey="PRIVACY_DIAGMON_CONSIGNMENT_AWS_OPERATIONS"
							components={{
								a: (
									// eslint-disable-next-line
									<a
										href="https://aws.amazon.com/ko/compliance/sub-processors/"
										target="_blank"
										rel="noreferrer"
									/>
								),
							}}
						/>,
					],
				],
			},
		],
	};

	return <Consignment data={data} testId="diagmon-consignment" />;
};

export default DiagmonConsignment;
